module.exports = __webpack_public_path__ + "img/car-wash.e80d020f.svg";